<!-- Action Templates -->
<ng-template let-entity="entity" #defaultActions>
  <a [routerLink]="['edit', entity.getPrimaryKey()]" class="btn btn-sm btn-primary btn-yellow" data-bs-toggle="tooltip" data-bs-placement="left" title="" data-bs-original-title="Station bearbeiten">
    <span data-bs-toggle="modal" data-bs-target="#stationEdit">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit">
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
      </svg>
    </span>
  </a>
  <a [routerLink]="['delete', entity.getPrimaryKey()]" class="btn btn-sm btn-primary btn-yellow ms-1" data-bs-toggle="tooltip" data-bs-placement="left" title="">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash">
      <polyline points="3 6 5 6 21 6"></polyline>
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
    </svg>
  </a>
</ng-template>

<!-- Column Templates -->
<ng-template let-column="column" let-entity="entity" #defaultColumnTemplate>
  <ngb-highlight [result]="resolveProperty(entity, column.property, column.options)" [term]="tableFunctions.searchTermMap.get(column.property)"></ngb-highlight>
</ng-template>

<ng-template let-column="column" let-entity="entity" #htmlColumnTemplate>
  <ngb-highlight [result]="resolveProperty(entity, column.property, column.options)" [innerHTML]="resolveProperty(entity, column.property, column.options)"  [term]="tableFunctions.searchTermMap.get(column.property)"></ngb-highlight>
</ng-template>

<ng-template let-column="column" let-entity="entity" #routerLinkColumnTemplate>
  <a [routerLink]="determineRouterLink(column.options.routerLink, entity)">
    <ngb-highlight [result]="resolveProperty(entity, column.property, column.options)" [term]="tableFunctions.searchTermMap.get(column.property)"></ngb-highlight>
  </a>
</ng-template>

<!-- Column Template Wrapper -->
<ng-template #columnWrapper>
  <ng-container *ngIf="column.options?.isHTML">
    <ng-container *ngTemplateOutlet="htmlColumnTemplate; context: { column: column, entity: entity }"></ng-container>
  </ng-container>

  <ng-container *ngIf="column.options?.isBoolean">
    <ng-container *ngTemplateOutlet="htmlColumnTemplate; context: { column: column, entity: entity }"></ng-container>
  </ng-container>

  <ng-container *ngIf="column.options?.routerLink">
    <ng-container *ngTemplateOutlet="routerLinkColumnTemplate; context: { column: column, entity: entity }"></ng-container>
  </ng-container>

  <ng-container *ngIf="!column.options?.routerLink && !column.options?.isHTML && !column.options?.isBoolean && !column.options?.useStatusBadgeComponent">
    <ng-container *ngTemplateOutlet="defaultColumnTemplate; context: { column: column, entity: entity }"></ng-container>
  </ng-container>
</ng-template>

<!-- Table -->
<ng-container>
  <div class="table-responsive table-wrapper">
    <table id="table" class="table" data-pagination="true" [ngClass]="tableOptions?.tableStyleClasses + (tableOptions?.showCheckboxes && ' table-with-checkboxes')">
      <thead [ngClass]="tableOptions?.theadStyleClasses">
        <tr class="filters">
          <th *ngIf="tableOptions?.showCheckboxes" scope="col">
            <form>
              <input
                type="checkbox"
                class="form-check-input"
                style="position: relative; margin-left: 0;"
                id="checkbox-all"
                (click)="checkboxAllClicked($event.target.checked)"
                [checked]="isCheckboxAllClicked">
            </form>
          </th>
          <th [class]="determineHeaderSortClass('index') + ' pos'" [sortable]="'index'" (sort)="onSort($event)" scope="col" *ngIf="tableOptions?.showNumbering">
            Pos.
          </th>
          <th [class]="determineHeaderSortClass(column.property)" [ngClass]="column.options?.tdStyleClasses" [sortable]="column.property" (sort)="onSort($event)" *ngFor="let column of tableColumns" scope="col">
            {{ column.columnDescription }}
          </th>
          <th *ngIf="!tableOptions?.hideActions" class="d-md-table-cell text-end" i18n="@@Options">Optionen</th>
        </tr>

        <!-- Filter per column -->
        <tr class="search">
          <th *ngIf="tableOptions?.showCheckboxes" scope="col" style="width:10px;max-width:10px;"></th>
          <th scope="col" *ngIf="tableOptions?.showNumbering"></th>
          <ng-container *ngIf="!tableOptions.hideSearch">
            <th *ngFor="let column of tableColumns" scope="col" [ngClass]="column.options?.tdStyleClasses">
              <input type="search" [ngModel]="tableFunctions.searchTermMap.get(column.property)" (ngModelChange)="tableFunctions.addToSearchTermMap(column.property, $event)" [placeholder]="''" />
            </th>
          </ng-container>
          <th *ngIf="!tableOptions?.hideActions" class="d-md-table-cell text-end"></th>
        </tr>
      </thead>

      <tbody>
        <ng-container *ngIf="(entities$ | async)?.length > 0; else noRecords">
          <tr class="d-md-table-row"
            *ngFor="let entity of entities$ | async; let i = index"
            [class]="getClasses(entity)" [style]="getModelPicture(entity) ">
            <!-- Checkbox -->
            <td *ngIf="tableOptions?.showCheckboxes">
              <form>
                <input
                  type="checkbox"
                  style="position: relative; margin-left: 0;"
                  class="form-check-input"
                  id="checkbox-{{index}}"
                  (click)="checkboxClicked(entity)"
                  [checked]="checkIfSelected(entity)">
              </form>
            </td>

            <!-- Numbering -->
            <td *ngIf="tableOptions?.showNumbering" class="pos">
              <span *ngIf="entity">{{ entity.index }}</span>
            </td>

            <!-- Columns -->
            <td *ngFor="let column of tableColumns"
              [ngClass]="column.options?.tdStyleClasses"
              [class]="column && column.options && column.options?.isLink ? 'link' : ''"
              [routerLink]="tableOptions?.rowRouterLink && determineRouterLink(tableOptions?.rowRouterLink, entity)">
              <ng-container *ngIf="column.options?.isHTML || column.options?.isLink">
                <ng-container *ngTemplateOutlet="htmlColumnTemplate; context: { column: column, entity: entity }"></ng-container>
              </ng-container>

              <ng-container *ngIf="column.options?.isBoolean">
                <ng-container *ngTemplateOutlet="htmlColumnTemplate; context: { column: column, entity: entity }"></ng-container>
              </ng-container>

              <ng-container *ngIf="column.options?.routerLink">
                <ng-container *ngTemplateOutlet="routerLinkColumnTemplate; context: { column: column, entity: entity }"></ng-container>
              </ng-container>

              <ng-container *ngIf="!column.options?.routerLink && !column.options?.isHTML && !column.options?.isBoolean && !column.options?.isLink && !column.options?.useStatusBadgeComponent">
                <ng-container *ngTemplateOutlet="defaultColumnTemplate; context: { column: column, entity: entity }"></ng-container>
              </ng-container>

              <ng-container *ngIf="column.options?.useStatusBadgeComponent">
                <charging-station-combined-status-badge [chargingStation]="entity"></charging-station-combined-status-badge>
              </ng-container>
            </td>

            <!-- Action Buttons -->
            <td class="text-end" *ngIf="!tableOptions?.hideActions">
              <ng-container *ngTemplateOutlet="actionsTemplate ? actionsTemplate : defaultActions; context: { entity: entity }"></ng-container>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</ng-container>

<ng-template #noRecords>
  <!-- <ng-container *ngIf="!tableOptions?.hideActions && !tableOptions?.showNumbering"> -->
  <ng-container>
    <tr>
      <!-- Checkbox -->
      <td *ngIf="tableOptions?.showCheckboxes" style="width:10px; padding-left:20px"></td>

      <!-- Numbering -->
      <!-- <td *ngIf="tableOptions?.showNumbering">
        <span *ngIf="entity">{{ entity.index }}</span>
      </td> -->

      <td attr.colspan="{{ tableColumns?.length + (tableOptions?.showNumbering ? 1 : 0) }}" class=" h-100 text-center align-middle">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg><br />
        <span class="pt-3" i18n="@@NoEntriesAvailable">Keine Einträge vorhanden.</span>
      </td>
      <td class="text-end" *ngIf="!tableOptions?.hideActions"></td>
    </tr>
  </ng-container>
</ng-template>
